import { render, staticRenderFns } from "./OpenAssignModal.vue?vue&type=template&id=b1986fc2&scoped=true&"
import script from "./OpenAssignModal.vue?vue&type=script&lang=js&"
export * from "./OpenAssignModal.vue?vue&type=script&lang=js&"
import style0 from "./OpenAssignModal.vue?vue&type=style&index=0&id=b1986fc2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1986fc2",
  null
  
)

export default component.exports